import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query CheckoutProductVariants($ids: [ID], $languageCode: LanguageCodeEnum!) {\n    productVariants(ids: $ids, first: 100) {\n      edges {\n        node {\n          ...ProductVariant\n        }\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query UserCheckoutDetails($languageCode: LanguageCodeEnum!) {\n    me {\n      id\n      checkout {\n        ...Checkout\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query CheckoutDetails($token: UUID!, $languageCode: LanguageCodeEnum!) {\n    checkout(token: $token) {\n      ...Checkout\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { checkoutFragment, checkoutProductVariantFragment } from "../fragments/checkout";
export var checkoutDetails = gql(_templateObject(), checkoutFragment);
export var userCheckoutDetails = gql(_templateObject2(), checkoutFragment);
export var checkoutProductVariants = gql(_templateObject3(), checkoutProductVariantFragment);